import React from 'react';
import type { Project } from '../../../data/projects';
interface ProjectVisualProps {
  project: Project;
}
export function ProjectVisual({
  project
}: ProjectVisualProps) {
  const isScreen = project.imageStyle === 'screen';
  const backScreen = project.gallery?.[0];
  return <div className="relative h-full w-full overflow-hidden" style={{
    background: project.tileColor
  }} data-id="element-229" data-mp="3bwuhgspgdsae">
      {project.image && isScreen ?
    // Product UI: framed screens that bleed off the right and bottom edges
    <>
          {backScreen && <img src={backScreen} alt="" aria-hidden="true" draggable={false} className="pointer-events-none absolute select-none" style={{
        top: '6%',
        left: '22%',
        width: '120%',
        maxWidth: 'none',
        borderRadius: 10,
        border: '1px solid rgba(23, 23, 22, 0.08)',
        boxShadow: '0 10px 30px rgba(23, 23, 22, 0.10)',
        opacity: 0.9
      }} data-id="element-230" data-mp="3lp0am5rfyfr6" />}
          <img src={project.image} alt={`${project.name} product screens`} draggable={false} className="pointer-events-none absolute select-none" style={{
        top: backScreen ? '20%' : '10%',
        left: '8%',
        width: '125%',
        maxWidth: 'none',
        borderRadius: 10,
        border: '1px solid rgba(23, 23, 22, 0.08)',
        boxShadow: '0 18px 40px rgba(23, 23, 22, 0.16)'
      }} data-id="element-231" data-mp="3oyklolxqwpxp" />
        </> : project.image ?
    // Case study slides are cropped from the right so the visuals show, not the slide copy
    <img src={project.image} alt={`${project.name} project visuals`} draggable={false} className="pointer-events-none absolute bottom-0 right-0 h-[110%] w-auto max-w-none select-none" data-id="element-232" data-mp="2iadxcbz1lfep" /> : project.logo ? <div className="flex h-full w-full items-center justify-center" data-id="element-233" data-mp="2f9st9rbpzg8i">
          <img src={project.logo} alt={project.name} draggable={false} className="pointer-events-none select-none" style={{
        height: 48,
        width: 'auto',
        filter: 'brightness(0)'
      }} data-id="element-234" data-mp="2b87c3ts5kfsi" />
        </div> : <div className="flex h-full w-full items-center justify-center px-8 text-center" data-id="element-235" data-mp="2y5shqs5ho1nc">
          <span className="font-aspekta text-3xl tracking-tight" style={{
        color: project.tileText
      }} data-id="element-236" data-mp="2u4777dgffzgb">
            {project.name}
          </span>
        </div>}
    </div>;
}